import React, { useMemo } from "react";
import { Table } from "reactstrap";
import numeral from "numeral";
import { Button } from "shared";

type RowItemProps = {
  row: any;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
};

const RowItem = ({ row, onDelete, onEdit }: RowItemProps) => {
  return (
    <tr>
      <td>
        <div>{row.month_year?.split?.("-")?.[0]}</div>
      </td>
      <td>
        <div>{row.month_year?.split?.("-")?.[1]}</div>
      </td>
      <td>
        <div className="content-end">
          {numeral(row.revenue_value).format("0,0")}
        </div>
      </td>
      <td>
        <div className="row-data-action">
          <Button
            label="Edit"
            type="primary"
            size="small"
            onClick={() => onEdit(row)}
          />
          <Button
            label="Delete"
            type="danger"
            size="small"
            onClick={() => onDelete(row)}
          />
        </div>
      </td>
    </tr>
  );
};

type SiteRevenueTableProps = {
  data: Array<any>;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
};

const SiteRevenueTable = ({
  data,
  onEdit,
  onDelete,
}: SiteRevenueTableProps) => {
  const renderRow = (row: any, index: number) => {
    return (
      <RowItem
        row={row}
        key={row.id || index}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    );
  };
  return (
    <Table responsive striped style={{ marginTop: 10 }}>
      <thead>
        <tr>
          <th>
            <div className="table-header">
              <span>Year</span>
            </div>
          </th>
          <th>
            <div className="table-header">
              <span>Month</span>
            </div>
          </th>
          <th>
            <div className="table-header">
              <span>Revenue</span>
            </div>
          </th>
          <th>
            <div className="table-header">
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>{data?.map?.(renderRow)}</tbody>
    </Table>
  );
};

export default SiteRevenueTable;
